import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import smsServiceNew from "../../../api/reservePlanNew.service";

import XLSX from "xlsx";
import moment from "moment";
import constants from "../../../config/constants";

export default {
  name: "view-current-sheets",
  components: { pageheader },
  data() {
    return {
      input: {},
      search: "",
      isDataLoading: false,
      currentSheetList: [],
      headers: [
        { text: "Name", value: "projectionName" },
        { text: "Location", value: "projectionLocation" },
        { text: "Start Date", value: "projectionStartDate" },
        { text: "End Date", value: "projectionEndDate" },
        { text: "Jobsite", value: "projectionJobSite" },
        { text: "Job#", value: "projectionJobNo" },
        { text: "PO#", value: "projectionPONo" },
        { text: "Comments", value: "projectionJobComments" },
        { text: "Status", value: "projectionStatus" },
        { text: "Creator", value: "projectionCreatorName" },
        { text: "Actions", value: "actions" },
      ],
      confirmDialog: false,
      isSubmit: false,
      titleOfproject: "",
      deleteConfirmDialog: false,
      isCurrentSheetRecordDelete: false,
      currentSheetDeleteId: "",
      excelHeader: [],
      reviewSubmitId: "",
      errorMSG: "",
    };
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsCustomerId",
      "smsUserId",
      "smsBirchLinkingId",
      "smsUserPermissions",
    ]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      } else {
        let emptydata = "";
        return emptydata;
      }
    },
  },
  async mounted() {
    this.input = utils.getInputContent("viewCurrentSheets", this.roles);

    if (
      this.$store.getters.companyIdDropdown == null ||
      this.$store.getters.companyIdDropdown == "" ||
      this.$store.getters.companyIdDropdown == undefined
    ) {
      this.errorMSG = constants.ERROR_COMPANY_NOT_SELECTED;
    } else {
      this.errorMSG = "";
      this.resetStoreGettersData();
      this.getCurrentActivityList();
    }
  },
  methods: {
    async resetStoreGettersData() {
      await this.$store.dispatch("setPlanningSheetTab", 1);
      await this.$store.dispatch("setStoreProjectionID", "");
      await this.$store.dispatch("setStoreReserveType", "");
      await this.$store.dispatch("setStoreProjectionItemEquipment", "");
      await this.$store.dispatch("setStoreProjectionItemID", "");
      await this.$store.dispatch("setprojectionRoute", "");
      this.$store.dispatch("setCopyOfProjectionName", "");
    },
    async getCurrentActivityList() {
      this.isDataLoading = true;
      let typeOfSheet;
      typeOfSheet = "current";
      try {
        let response = await smsServiceNew.getActivityList(typeOfSheet);
        if (response && response.isSuccess && response.data) {
          this.currentSheetList = response.data;
          this.isDataLoading = false;
        } else {
          this.currentSheetList = [];
          this.isDataLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isDataLoading = false;
      }
    },
    copyProject(item) {
      this.$store.dispatch("setPlanningSheetTab", 1);
      this.$store.dispatch("setStoreProjectionID", item.projectionID);
      this.$store.dispatch("setStoreReserveType", "Copy");
      this.$store.dispatch("setStoreProjectionItemEquipment", "");
      this.$store.dispatch("setStoreProjectionItemID", "");
      this.$router.push({ name: "Create Planning Sheet" });
      this.$store.dispatch("setprojectionRoute", "Historical Sheets");
      this.$store.dispatch("setCopyOfProjectionName", item.projectionName);
    },
    editProjectItemDetails(item) {
      this.$store.dispatch("setPlanningSheetTab", 1);
      this.$store.dispatch("setPlanningSheetTabPrev", 1);

      this.$router.push({ name: "Create Planning Sheet" });
      this.$store.dispatch("setStoreProjectionID", item.projectionID);
      this.$store.dispatch("setStoreReserveType", "Edit");
      this.$store.dispatch("setStoreProjectionItemEquipment", "");
      this.$store.dispatch("setStoreProjectionItemID", "");
      this.$store.dispatch("setprojectionRoute", "Current Sheets");
    },
    async unlockProject(item) {
      try {
        let response = await smsServiceNew.unlockPlanningsheet(
          item.projectionID
        );
        if (response && response.isSuccess) {
          this.$toast.success("Unlocked the project successfully");
          this.getCurrentActivityList();
        } else {
          this.$toast.error("Unable to unlock the project");
        }
      } catch (err) {
        this.$toast.error("Unable to unlock the project");
        console.log(err);
      }
    },
    viewProjectItemDetails(item) {
      this.$store.dispatch("setPlanningSheetTab", 3);
      this.$store.dispatch("setPlanningSheetTabPrev", null);

      this.$store.dispatch("setStoreProjectionID", item.projectionID);
      this.$store.dispatch("setPlanningSheetObj", item);
      this.$store.dispatch("setStoreReserveType", "View");
      this.$router.push({ name: "Create Planning Sheet" });
      this.$store.dispatch("setprojectionRoute", "Current Sheets");
    },
    // Delete Current Sheet Row Start
    openDeleteProjectItem(item) {
      this.deleteConfirmDialog = true;
      this.titleOfproject = item.projectionName;
      this.currentSheetDeleteId = item.projectionID;
    },
    closeDeleteDialog() {
      this.deleteConfirmDialog = false;
    },
    async deleteCurrentSheetItem() {
      this.isCurrentSheetRecordDelete = true;
      try {
        let response = await smsServiceNew.deleteCurrentSheetRecord(
          this.smsUserId,
          this.currentSheetDeleteId
        );
        if (response && response.isSuccess) {
          this.isCurrentSheetRecordDelete = false;
          this.$toast.success("Deleted planning sheet successfully");
          this.closeDeleteDialog();
          this.getCurrentActivityList();
        } else {
          this.isCurrentSheetRecordDelete = false;
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        console.log(err);
        this.isCurrentSheetRecordDelete = false;
        this.$toast.error("Unable to delete");
      }
    },
    // Delete Current Sheet Row End - * -
    //SUbmit Project for Review Start
    openSubmitDialog(item) {
      this.confirmDialog = true;
      this.titleOfproject = item.projectionName;
      this.reviewSubmitId = item.projectionID;
    },
    CloseDialog() {
      this.confirmDialog = false;
    },
    //4th icon click
    async submitProject() {
      this.isSubmit = true;
      try {
        let response = await smsServiceNew.finalSubmitOfItems(
          this.reviewSubmitId
        );
        if (response && response.isSuccess) {
          this.isSubmit = false;
          this.$toast.success("Project submitted successfully");
          this.getCurrentActivityList();
          this.CloseDialog();
        } else {
          this.isSubmit = false;
          this.$toast.error("Unable to submit the Project");
        }
      } catch (err) {
        console.log(err);
        this.isSubmit = false;
        this.$toast.error("Unable to submit the Project");
      }
    },
    //SUbmit Project for Review End - * -
    downloadExcel() {
      this.excelHeader.push(["Current Sheet Data"]);
      this.excelHeader.push([]);
      this.excelHeader.push([
        "Name",
        "Location",
        "Start Date",
        "End Date",
        "Jobsite",
        "Job #",
        "PO #",
        "Comments",
        "Status",
        "Creator",
      ]);

      let tempExcel = this.currentSheetList.map(function (item) {
        delete item.projectionID;
        delete item.customerID;
        delete item.birchUserID, delete item.canDeletePlanningSheet;
        delete item.canLockPlanningSheet;
        delete item.projectionCreatorUserID;
        delete item.projectionJobSiteNo;
        return item;
      });
      for (var i = 0; i < tempExcel.length; i++) {
        if (tempExcel[i]["projectionStartDate"]) {
          tempExcel[i]["projectionStartDate"] = moment(
            tempExcel[i]["projectionStartDate"]
          ).format("MM/DD/YYYY");
        }
        if (tempExcel[i]["projectionEndDate"]) {
          tempExcel[i]["projectionEndDate"] = moment(
            tempExcel[i]["projectionEndDate"]
          ).format("MM/DD/YYYY");
        }
      }
      // Data starts on the row after the header rows pushed above.
      let datarow = "A" + (this.excelHeader.length + 1);
      var ws = XLSX.utils.aoa_to_sheet(this.excelHeader);
      XLSX.utils.sheet_add_json(ws, tempExcel, {
        header: [
          "projectionName",
          "projectionLocation",
          "projectionStartDate",
          "projectionEndDate",
          "projectionJobSite",
          "projectionJobNo",
          "projectionPONo",
          "projectionJobComments",
          "projectionStatus",
          "projectionCreatorName",
        ],
        skipHeader: true,
        origin: datarow,
      });
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Current Sheet Data");
      this.excelHeader = [];
      XLSX.writeFile(wb, "Current Sheet Data.xlsx");
    },
    newPlanningSheet() {
      this.$store.dispatch("setPlanningSheetTab", 1);
      this.$store.dispatch("setStoreProjectionID", "");
      this.$store.dispatch("setPlanningSheetObj", {});
      this.$router.push({ name: "Create Planning Sheet" });
    },
  },
};
